<template>
  <div class="Rightcontent">
      <router-view />
  </div>
</template>

<script>
export default {
  props: ['isCollapse'],
  methods: {
    change () {
      this.$emit('changeCollapse')
    }
  }
}
</script>

<style>
  ::-webkit-scrollbar {
    width: 0;
    display: none;
  }
.Rightcontent{
  width: calc(100vw - 203px);
  margin: 20px;
  background: ;
}
</style>



// WEBPACK FOOTER //
// src/view/LayOut/Rightcontent.vue